<div fxFlex="0 0 100%" fxLayout="row wrap" class="assignments-select">
    <app-sticky-header
        fxFlex="grow"
        [title]="data.title"
        [context]="data.context"
        [contextIcon]="data.contextIcon"
        (onSubmit)="submit()"
        (onCancel)="bottomSheetRef.dismiss()"
        [savingStatus]="!!(saving | async)"
        [enableSubmit]="!Utils.isEmpty(contentCollectionForm.value.title_translation)"
    ></app-sticky-header>
    <div class="user-manage-cp-access" fxFlex="grow" ngClass.xs="xs">
        <app-title-translation
            type="title"
            class="title-trans-section"
            placeholder="Insert section title"
            i18n-placeholder
            [formControl]="contentCollectionForm.get('title_translation') | cast"
        ></app-title-translation>
        <div [ngSwitch]="data.scope">
            <app-content-collection-sections-select
                *ngSwitchCase="AppScope.SECTIONS"
                [accessForm]="contentCollectionForm"
                [referenceFilter]="data.referenceFilter"
                [defaultSorting]="data.defaultSorting"
                [params]="data.params"
            ></app-content-collection-sections-select>
            <app-content-collection-resources-select
                *ngSwitchCase="AppScope.RESOURCES"
                [accessForm]="contentCollectionForm"
                [referenceFilter]="data.referenceFilter"
                [defaultSorting]="data.defaultSorting"
                [params]="data.params"
            ></app-content-collection-resources-select>
        </div>
    </div>
</div>
